import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePriceListCreate,
  detail: routePriceListDetail,
  home: routePriceListsHome,
  root: routePriceListsRoot,
} = createDoctypeRoutes({
  createName: 'new-price-list',
  createPath: 'new-price-list',
  detailName: 'priceListDetail',
  doctype: DOCTYPES.PRICE_LIST,
  homeName: 'price-lists',
  path: 'price-lists',
  views: {
    create: async () => await import('@/components/viewsExternal/priceLists/AddPriceList.vue'),
    detail: async () => await import('@/components/viewsExternal/priceLists/ViewPriceList.vue'),
    list: async () => await import('@/components/viewsExternal/prices/ViewPrices.vue'),
  },
})

export { routePriceListCreate, routePriceListDetail, routePriceListsHome, routePriceListsRoot }
